import { render } from "./ContactsCardComponent.vue?vue&type=template&id=e87f24c4&scoped=true"
import script from "./ContactsCardComponent.vue?vue&type=script&lang=js"
export * from "./ContactsCardComponent.vue?vue&type=script&lang=js"

import "./ContactsCardComponent.vue?vue&type=style&index=0&id=e87f24c4&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e87f24c4"]])

export default __exports__